import React from "react";
import Login from "./Login";

function RegisterRestaurant() {
  return (
    <div>
      <Login restaurantProp={true} />
    </div>
  );
}

export default RegisterRestaurant;
